<template>
  <div class="billing-cycle-label">
    <h3 class="billing-cycle-label-month">{{ month }}</h3>
    <div class="billing-cycle-label-year">{{ year }}</div>
  </div>
</template>

<script>
export default {
  name: 'BillingCycleLabel',
  props: {
    name: {
      type: String,
    },
  },
  computed: {
    nameParts() {
      return this.name ? this.name.split(' ') : '';
    },
    month() {
      return this.nameParts[0];
    },
    year() {
      return this.nameParts[1];
    },
  },
};
</script>

<style scoped>
.billing-cycle-label {
  text-align: right;
  padding: 0.75rem;
}
.billing-cycle-label-month {
  font-weight: 500;
  font-size: 1.25rem;
  line-height: 1.125rem;
}
.billing-cycle-label-year {
  font-size: 0.875rem;
  font-weight: 400;
}
</style>
